<!-- webView -->
<div class="container-fluid webView" style="padding: 0px 5px;">
    <div class="col-md-12 col-12 col-sm-12" style="display: flex; align-items: center; padding: 15px 0px;">
        <div class="col-md-6 col-sm-6">
            <h2 class="header lblHeader newHeader">
                Day Book
            </h2>
        </div>
        <div class="col-md-6 col-sm-6" style="text-align: right; display: flex; justify-content: end;">
            <div>
                <span class="fa fa-search" style="padding-left: 13px; font-size: 14px;
                position: absolute;top: 8px;color: #999;"></span>
                <input class="form-control formCtlFltr brdrRadius3" placeholder="Search" matInput (keyup)="searchFilter($event)"  style="text-align: left; background-color: white; display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 240px !important; height: 28px !important; margin: 0px;" type="text">   
            </div>
            <div>
                <span class="btn darkBlueButton" (click)="exportToExcelActivities()" title="Export to Excel"
                    style="cursor:pointer;margin-left: 10px;float: right;padding:3px 9px;font-size: 12px;float: right;"><span><i
                        class="fa fa-file-excel-o" aria-hidden="true"></i></span>
                </span>
            </div>
  
            <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
                <span class="darkBlueButton" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                </span>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12" style="display: flex;">
    
        <div  style="display: flex;padding: 0px;">
            <div style="display: inline-block; align-content: center;">
              <label style="font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                for="sel1">Month : </label>
            </div>
          
            <div style="margin-left: 6px;">
              <select  class="form-control bgwhite formCtlFltr bzInput" style="box-shadow: none;width: 100px;cursor: pointer; padding: 4px;" [(ngModel)]="monthDisplay"
                (change) ="trasYearChange()">
                <option *ngFor="let i of months;">{{i.display}}</option>
              </select>
            </div>
            <div style="display: flex; margin-left: 10px; gap: 8px;">
                <span class="align-middle" style="cursor: pointer;">
                  <input 
                    type="checkbox" 
                    id="Selected"
                    class="form-control chkbox-darkblue w-[15px]"
                    [(ngModel)]="dateFilter.showDatePicker"
                    (change)="toggleDatepicker(view.month, view.year)"
                    style="margin-bottom: 1px; cursor: pointer;"
                  />
                </span>
                <label 
                  for="Selected" 
                  style="font-size: 13px; margin-bottom: 0px; display: flex; align-items: center; cursor: pointer;"
                >
                <div>
                    Select Date
                </div>
                  
                </label>
            </div>
            <div *ngIf="dateFilter.showDatePicker" class="align-middle ml-2.5" style="margin-left: 8px;">
                <input 
                  type="text" 
                  id="txtFinishDate"
                  tabindex="1"
                  [(ngModel)]="selDate"
                  (ngModelChange)="toggleDatepicker(view.month, view.year)"
                  class="form-control fontSizeHead BzBgwhite formCtlFltr borderCol bzInput"
                  [matDatepicker]="picker"
                  [max]="maxDate"
                  [min]="minDate"
                  readonly
                  placeholder="Select Date"
                  (click)="picker.open()"
                  style="background-color: white; padding: 6px; width: 90px;"
                />
                <mat-datepicker #picker></mat-datepicker>
              </div>
              
        </div>
    </div>
    
    <!-- Table -->
    <div class="wrapper" style="overflow: auto; padding-left: 0px !important; text-overflow: ellipsis; white-space: nowrap; padding-top: 8px; padding-right: 14px;border-radius: 3px; padding-left: 15px !important; padding-bottom: 10px;" *ngIf="dataSource.data.length > 0">
      <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px; width: 100%;" id="excel-table">
        <!-- <ng-container matColumnDef="Date">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header >
                <label style="font-size: 13px;">Date</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.CreatedDT}} </td>
        </ng-container> -->

        <ng-container matColumnDef="Voucher No">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="VoucherNo" style="cursor: pointer; width: 6%;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Vchr No.</label>
            </th>
            <td mat-cell *matCellDef="let item"><span>{{item.VoucherNo ? item.VoucherNo : '-'}}</span></td>
        </ng-container>

        <ng-container matColumnDef="Voucher Type">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="voucherType" style="cursor: pointer; width: 9%;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Voucher Type</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.voucherType}} </td>
        </ng-container>

        <ng-container matColumnDef="Credit">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="MainCrLedger" style="cursor: pointer; width: 15%;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Credit</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.MainCrLedger}} </td>
        </ng-container>
        <ng-container matColumnDef="Debit">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="MainDbLedger" style="cursor: pointer; width: 15%;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Debit</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.MainDbLedger}} </td>
        </ng-container>
        <ng-container matColumnDef="Amount">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="CrAmt" style="cursor: pointer;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Amount (₹)</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: right; padding-right: 20px;"> {{item.CrAmt | lacFormat}} </td>
        </ng-container>
        <ng-container matColumnDef="Voucher Date">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="effectiveDate" style="cursor: pointer; width: 6%;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Vchr Date</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.effectiveDate}} </td>
        </ng-container>

        <ng-container matColumnDef="Entered By">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="createdBy" style="cursor: pointer;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Entered by</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.createdBy}} </td>
        </ng-container>

        <ng-container matColumnDef="Entered Date">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="createdDT" style="cursor: pointer;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer; width: 6%;">Entered on</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left;" title="{{item.createdTime}}"> {{item.createdDT}} </td>
        </ng-container>
        <ng-container matColumnDef="Updated By">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="updatedBy" style="cursor: pointer;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Updated by</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.updatedDT != '-' ? item.updatedBy : '-'}} </td>
        </ng-container>
        <ng-container matColumnDef="Updated Date">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header="updatedDT" style="cursor: pointer;">
                <label style="font-size: 13px; margin-bottom: 0px; cursor: pointer;">Updated on</label>
            </th>
            <td mat-cell *matCellDef="let item"> {{item.updatedDT ?( item.updatedDT) : '-' }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
     
     <mat-paginator style="border-bottom-left-radius: 3px !important; border-bottom-right-radius: 3px !important;"
          [pageSizeOptions]="[10, 15]" showFirstLastButtons>
     </mat-paginator>
  </div>
  <div *ngIf="dataSource.data.length == 0">
    <div style="margin: 15px; margin-left: 15px;" class="nrf brdrRadius3">No vouchers found.</div>
  </div>
</div>


<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>